import React from 'react';
import Modal from 'react-modal';
import { IDeleteLinkConfirmationModalProps } from './types';
import { ButtonComponent } from '@syncfusion/ej2-react-buttons';

export const DeleteLinkConfirmationModal: React.FC<IDeleteLinkConfirmationModalProps> = ({
  hasPermission,
  onConfirm,
    onCancel,
    contactLinksCount,
    selectedLink // 45886 - TO - 06/11/2024
}) => (
  <Modal isOpen className="model-content" overlayClassName="modal-overlay">
    <div>
      {selectedLink.type !== 'Member' ? (
        <>
          <h1 className="text-center">Warning</h1>
          <div>
            <p className="mt-3">Only the 'Member' role can be deleted.</p>
            <p className="mt-3">
              If the role you are attempting to delete relates to group committee changes, please use the 'Group Committee Change' form to request this role deletion.
            </p>
            <p className="mt-3">
              To delete any other roles, please contact the Customer Care Team for further assistance.
            </p>
          </div>
        </>
      ) : (
        <>
          <h1 className="text-center">Member Group Link</h1>
          {hasPermission ? (
            <div>
              <p className="mt-3">
                Do you wish to remove this link (Group Role) between member and the Local Group?
              </p>
              {contactLinksCount === 1 &&
                <p className="mt-3 text-danger">
                  WARNING: Deleting the last link will mark this contacts group address as inactive.
                </p>
              }
            </div>
          ) : (
            <div>
              <p className="mt-3">
                You are not authorised to remove a membership link belonging to another Group.
              </p>
            </div>
          )}
        </>
      )}
      <div className="d-flex justify-content-between mt-3">
        <ButtonComponent type="button" onClick={onCancel}>
          {hasPermission && selectedLink.type === 'Member' ? 'No' : 'Close'}
        </ButtonComponent>
        {(hasPermission && selectedLink.type === 'Member') && (
          <ButtonComponent
            type="button"
            cssClass="mr-2 e-danger"
            onClick={onConfirm}
          >
            Yes
          </ButtonComponent>
        )}
      </div>
    </div>
  </Modal>
);
